import api from './api';
import { IFaleconosco } from '../common/interfaces/faleconosco.interfaces';

export function enviar(faleconosco : IFaleconosco) {
    return api.post('/faleconosco', faleconosco).then(res => res.data);
}